import { useEffect, useState } from "react";
import {
    setDeepLinkCookieFromUrlParams,
    setExperimentalFlagsFromUrlParams,
} from "@utils/domainUtils";

export const useProcessUrlParams = () => {
    const [isCompleted, setIsCompleted] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(document.location.search);
        setIsCompleted(false);

        setDeepLinkCookieFromUrlParams(urlParams);
        setExperimentalFlagsFromUrlParams(urlParams);

        setIsCompleted(true);
    }, []);

    return isCompleted;
};
